import { useContext } from "react";
import { useQuery } from "react-query";
import { BRANCH_ENDPOINT, buildBranchCacheKey } from ".";
import {
  IGetBranchInput,
  IGetBranchOutput,
} from "../../../../api-schema/branch";
import { AuthContext } from "../../contexts/AuthProvider";
import { getRequest } from "../apiClient";

const getBranch = async (
  { bId }: IGetBranchInput,
  token: string
): Promise<IGetBranchOutput> => {
  const result = await getRequest<IGetBranchOutput>(
    BRANCH_ENDPOINT,
    {
      bId,
    },
    token
  );
  return await result;
};

export const useBranchData = ({ bId }: IGetBranchInput) => {
  const { token } = useContext(AuthContext);
  const { data, isLoading, isError } = useQuery<IGetBranchOutput>(
    buildBranchCacheKey({ bId }),
    () => getBranch({ bId }, token),
    { cacheTime: Infinity }
  );
  return { data, isLoading, isError };
};
